import React from "react";
import { bind } from "decko";
import L1PlayerSelector from "./L1PlayerSelector";

export default class KeeperSelector extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            keeperSelectorVisible: props.keeper === null || props.keeper.id === null,
        }
    }

    @bind
    toggleKeeperSelectorVisible () {
        this.setState({keeperSelectorVisible: !this.state.keeperSelectorVisible});
    }

    @bind
    selectKeeper (keeper) {
        let safeKeeperObj = keeper !== null ? keeper : {
            type: "player",
            id: null,
            value: "",
        };
        this.props.onKeeperSelected(safeKeeperObj);
        this.toggleKeeperSelectorVisible();
    }

    render () {
        const {keeper, team, lineup} = this.props;
        return (
            <div>
                <div className="col-xs-12 text-center"
                     style={{marginTop: "10px", cursor: "pointer"}} onClick={this.toggleKeeperSelectorVisible}>
                    {keeper.id === null && (
                        <span style={{color: "darkred"}}>WARNING: Keeper missing from tactical lineup. Please select</span>
                    )}
                    {keeper.id !== null && (
                        `Conceding Keeper ${keeper.value}`
                    )}
                    <span
                        className={"glyphicon " + (this.state.keeperSelectorVisible ? "glyphicon-menu-down" : "glyphicon-menu-up")}
                        style={{marginLeft: "10px", top: "5px"}} />
                </div>
                {this.state.keeperSelectorVisible && (
                    <div className="col-xs-12 text-center" style={{marginTop: "10px"}}>
                        <L1PlayerSelector
                            player={keeper}
                            lineup={lineup}
                            selectedTeam={team}
                            onChange={this.selectKeeper}
                        />
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/js/KeeperSelector.js